import { render } from "./custom-section.vue?vue&type=template&id=a875a3d4&scoped=true"
import script from "./custom-section.vue?vue&type=script&lang=js"
export * from "./custom-section.vue?vue&type=script&lang=js"

import "./custom-section.vue?vue&type=style&index=0&id=a875a3d4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a875a3d4"]])

export default __exports__